import { httpClient } from "./httpClient";

type Payload = {
  feedbackType: string;
  businessUnit: string;
  feedbackSubject: string;
  details: string;
  screenshotURL?: string;
};

type Data = any;

export async function postFeedback(payload: Payload): Promise<any> {
  try {
    const { data } = await httpClient.post<Data>(`/api/v1/feedback`, payload);

    return data;
  } catch (error) {
    throw error;
  }
}
